import React from 'react'

const PaymentsReceived = () => {
  return (
    <div>PaymentsReceived</div>
  )
}

export default PaymentsReceived